import { useState } from "react";
import Reveal from "@/components/base/Reveal";

const IMAGES = [
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/eec2b81b-c1fa-45a7-b4a0-4ebae3347cb5_compressed_powermotoreseletricos-15.webp",
    alt: "Motores WEG azuis na oficina da Power",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/f38fb710-11d7-4014-b76f-555bdc7fdb2d_compressed_powermotoreseletricos-11.webp",
    alt: "Motor elétrico WEG azul - vista superior",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/b6e91c1b-69d0-4602-8eeb-3accab349a51_compressed_powermotoreseletricos-5.webp",
    alt: "Motor elétrico WEG de grande porte no galpão",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/df935c2d-0c9a-49b9-8d6b-55f1e768305c_compressed_powermotoreseletricos-12.webp",
    alt: "Motor elétrico WEG azul sobre pallet - vista superior",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/7d6a32d9-e429-4639-ba5f-9f01ff1fb38b_compressed_powermotoreseletricos-1.webp",
    alt: "Múltiplos motores elétricos WEG azuis sobre pallet",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/f4f0b287-0b0a-421e-9414-a409163eda27_compressed_powermotoreseletricos-4.webp",
    alt: "Motor elétrico WEG recondicionado laranja - vista frontal",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/91c3dd83-8272-4e9a-9595-f14280349a53_compressed_powermotoreseletricos-13.webp",
    alt: "Motor elétrico WEG azul com etiqueta de identificação",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/be905cfd-9451-4f2b-bcfe-60a259e58cc5_compressed_powermotoreseletricos-14.webp",
    alt: "Motor elétrico WEG azul com motor recondicionado ao fundo",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/ff171496-2c4d-4718-a43a-e4d74c3a5eed_compressed_powermotoreseletricos-6.webp",
    alt: "Motor elétrico WEG azul industrial - vista lateral",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/bdba5d67-40e4-4292-a2b8-e6d8138963ee_compressed_powermotoreseletricos-16.webp",
    alt: "Motor elétrico WEG azul dentro do galpão da Power",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/df656806-14ee-43eb-9e74-dafa5bcb22b1_compressed_powermotoreseletricos-17.webp",
    alt: "Motor elétrico WEG azul - vista lateral no galpão",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/c5160550-bed4-4688-b6c7-567185f6d35f_compressed_powermotoreseletricos-9.webp",
    alt: "Motor elétrico WEG azul sobre pallet de madeira",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/eac7c76f-cb67-494b-a4b7-b65d729674b1_compressed_powermotoreseletricos-18.webp",
    alt: "Motor elétrico WEG azul - vista superior com eixo",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/20a0af5d-f68a-49a1-b05e-758bea275301_compressed_powermotoreseletricos-19.webp",
    alt: "Dois motores elétricos WEG azuis lado a lado",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/41572e70-d124-4563-9a16-d76dea9ac4ae_compressed_powermotoreseletricos-10.webp",
    alt: "Motor elétrico WEG azul em estoque com bobinas ao fundo",
  },
];

export default function Gallery() {
  const [active, setActive] = useState<number | null>(null);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Conheça a Power de perto
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-base text-foreground-600">
            Estrutura, processos e equipe dedicados a manter seus equipamentos em movimento.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3">
          {IMAGES.map((img, i) => (
            <Reveal
              key={img.alt}
              delay={i * 50}
              className={i === 0 ? "col-span-2 row-span-2" : "col-span-1"}
            >
              <button
                type="button"
                onClick={() => setActive(i)}
                className="group relative block h-full w-full overflow-hidden rounded-lg border border-background-200"
                aria-label={`Ampliar imagem: ${img.alt}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  title={`${img.alt} - Power Motores Elétricos`}
                  className={`w-full object-cover object-center transition-transform duration-300 group-hover:scale-[1.03] ${
                    i === 0 ? "h-full min-h-[320px] md:min-h-[420px]" : "h-40 md:h-48"
                  }`}
                />
                <span className="absolute inset-0 flex items-center justify-center bg-primary-950/0 opacity-0 transition-all group-hover:bg-primary-950/40 group-hover:opacity-100">
                  <i className="ri-zoom-in-line text-3xl text-background-50" aria-hidden="true" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {active !== null && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-primary-950/90 p-4"
          role="dialog"
          aria-modal="true"
          aria-label="Visualização de imagem"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            onClick={() => setActive(null)}
            className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-md bg-background-50/10 text-background-50 hover:bg-background-50/20"
            aria-label="Fechar"
          >
            <i className="ri-close-line text-2xl" aria-hidden="true" />
          </button>
          <img
            src={IMAGES[active].src}
            alt={IMAGES[active].alt}
            className="max-h-[85vh] max-w-full rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}